import { render } from "./_new.vue?vue&type=template&id=44a5e66c"
import script from "./_new.vue?vue&type=script&lang=js"
export * from "./_new.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__